import * as yup from 'yup';

import { RestockingRuleFormValues } from './RestockingRuleFields';

const WEEKDAY_FREQUENCIES: RestockingRuleFormValues['frequency'][] = [
  'WEEKLY',
  'EVERY_TWO_WEEKS',
  'EVERY_THREE_WEEKS',
  'EVERY_FOUR_WEEKS',
];

export const restockingRuleFormValidationSchema: yup.SchemaOf<RestockingRuleFormValues> = yup.object({
  categoryIds: yup.array().of(yup.string().defined()),
  productFamilyIds: yup
    .array()
    .of(yup.string().defined())
    .when('categoryIds', {
      is: (categoryIds: string[]) => categoryIds.length > 0,
      then: yup.array().of(yup.string()).min(0),
      otherwise: yup.array().of(yup.string()).min(1),
    }),
  type: yup.mixed<RestockingRuleFormValues['type']>().oneOf(['AUTO_RESTOCKING', 'REMINDER']).required(),
  frequency: yup
    .mixed<RestockingRuleFormValues['frequency']>()
    .oneOf(['DAILY', 'WEEKLY', 'EVERY_TWO_WEEKS', 'EVERY_THREE_WEEKS', 'EVERY_FOUR_WEEKS', 'SOLD_OUT_FOR_X_DAY'])
    .required(),
  weekdays: yup.array<RestockingRuleFormValues['weekdays']>(yup.string()).when('frequency', {
    is: (frequency: RestockingRuleFormValues['frequency']) => WEEKDAY_FREQUENCIES.includes(frequency),
    then: yup.array<RestockingRuleFormValues['weekdays']>(yup.string()).min(1),
  }),
  applyAfterDays: yup.number().when('frequency', {
    is: 'SOLD_OUT_FOR_X_DAY',
    then: yup.number().defined().positive().max(365),
  }),
  timeInMinutes: yup.number().required(),
  startDate: yup.date().required(),
  ruleName: yup.string().trim().defined().max(70).required(),
});
